/** Socket.IO base URL — local admin UI always uses the Vite proxy in dev. */
export function socketBaseUrl(): string {
  const origin = window.location.origin;
  if (import.meta.env.DEV) return origin;
  const fromEnv = import.meta.env.VITE_SOCKET_URL;
  if (typeof fromEnv === 'string' && fromEnv.trim()) return fromEnv.trim().replace(/\/$/, '');
  return origin;
}

/** Polling-only in dev avoids noisy websocket upgrade failures during React Strict Mode remounts. */
export function socketIoOptions() {
  if (import.meta.env.DEV) {
    return {
      transports: ['polling'] as ('polling' | 'websocket')[],
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 2000,
    };
  }
  return {
    transports: ['polling', 'websocket'] as ('polling' | 'websocket')[],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 2000,
  };
}

/** @deprecated use socketIoOptions() */
export const SOCKET_IO_OPTIONS = {
  transports: ['polling', 'websocket'] as ('polling' | 'websocket')[],
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 2000,
};